import { useEffect, useState } from "react";
import { FiExternalLink } from "react-icons/fi";
import { makeAjax, respStatus, url } from "../../helpers/global_helper";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const initSetting = {
  floating_link_pf: null,
  class: null,
  default_class: null,
};

const FloatingComponents = (props) => {
  const [fnSetting, setFnSetting] = useState(initSetting);
  const [showTopBtn, setShowTopBtn] = useState(false);
  const [alternativeSite, setAlternativeSite] = useState([]);
  const { componentSetting } = useSelector((state) => ({
    componentSetting: state.componentSettingListR.data,
  }));

  const getAlternativeSite = () => {
    let alt_site = localStorage.getItem('alternative_site');
    if (!alt_site)
      alt_site = "[]";
    setAlternativeSite(JSON.parse(alt_site));
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 400) setShowTopBtn(true);
      else setShowTopBtn(false);
    });
    getAlternativeSite();
  }, []);

  useEffect(() => {
    let temp = { ...fnSetting };
    temp["floating_link_pf"] =
      componentSetting?.["floating-components"]?.["default-value"];
    temp["default_class"] =
      componentSetting?.["floating-components"]?.["default-value"];
    setFnSetting(temp);
  }, [componentSetting?.["floating-components"]]);

  return (
    <>
      {fnSetting["floating_link_pf"] && (
        <div className="floating-link" >
          <div className={`${fnSetting["default_class"]} text-alternate_link background-alternate_link`} fluid="true">
            <li>
              <FiExternalLink />
              <p className="alter">{props.t("alternative_links")}</p>{" "}
            </li>
            <ol className="link_ol">
              {alternativeSite.map(
                (v, i) =>
                  v?.is_user_app_visibility && (
                    <li key={i}>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={
                          v.is_secured
                            ? "https://" + v.domain
                            : "http://" + v.domain
                        }
                      >
                        {v.domain}
                      </a>
                    </li>
                  )
              )}
            </ol>
          </div>
        </div>
      )}
    </>
  );
};

FloatingComponents.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(FloatingComponents);
